import { IconButtonProps } from "@mui/material";
import React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppRemoveIcon } from "../../Icon/AppRemoveIcon";
import { AppToolButton } from "ui/Scripts/source/components/framework/Button/AppToolButton";

interface IRemoveToolButtonProps extends IconButtonProps {
    tooltip?: string
}

export const RemoveToolButton = (props: IRemoveToolButtonProps) => (
    <AppToolButton
        {...props}
        color="error"
        tooltip={props.tooltip ?? Translations.Remove}
        icon={<AppRemoveIcon />}
    />
);
